import { render, staticRenderFns } from "./consumeOrderList.vue?vue&type=template&id=9f0a8b42&scoped=true&"
import script from "./consumeOrderList.vue?vue&type=script&lang=js&"
export * from "./consumeOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f0a8b42",
  null
  
)

export default component.exports